export default {
    title_list: 'Теги',
    title_page: 'Тег',
    title_create_page: 'Создать тег',
    title_edit_page: 'Изменить тег',

    filter: {
        labels: {
            title: 'Название',
            activated: 'Активирован',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Название',
            user_id: 'Пользователь',
            activated: 'Активирован',
        }
    },

    buttons: {

    },

    form: {
        title: 'Название',
        user_id: 'Пользователь',
        activated: 'Активирован',
    },
}
